import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BUILD_INFO } from '../../build-info';

@Component({
  standalone: true,
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
  ]
})
export class TermsAndConditionsComponent implements OnInit {
  private readonly termsAndConditionsVersion = 'v1';
  private readonly storageKey = 'pb_terms_accepted';
  readonly build = BUILD_INFO;

  challenge = this.makeChallenge();
  acceptText = '';

  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    this.acceptText = '';
  }
  get canAccept(): boolean {
    const typed = this.acceptText?.trim() ?? '';
    return typed.length > 0 && typed === this.challenge;
  }

  accept(): void {
    if (!this.canAccept) return;

    const payload = {
      accepted: true,
      version: this.termsAndConditionsVersion,
      acceptedAtIso: new Date().toISOString(),
    };

    localStorage.setItem(this.storageKey, JSON.stringify(payload));
    this.router.navigateByUrl('/');
  }

  decline(): void {
    localStorage.removeItem(this.storageKey);
    this.router.navigateByUrl('/');
  }

  private makeChallenge(): string {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz23456789'; // no O/0/I/1 confusion
    const part = (len: number) =>
    Array.from({ length: len }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    return `PB-${part(4)}-${part(4)}`;
  }
}
